import { Descriptions, Dropdown, Input, Table } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import InsideHeader from "../../../components/InsideHeader";
import { fetchItemLedger } from "../../../features/dropdown/dropdownSlice";
import { cashConverter, dateForHumans, formatMoney } from "../../../utils";
import svg56 from "../../../assets/svg/svg56.svg";
import Search from "../../../components/Search";
import DeleteModal from "../../../components/DeleteModal";
import AddLedgerItemModal from "../modal/AddLedgerItemModal";
import { deleteItemLedger } from "../../../features/staff-setting/staffSettingSlice";
import toast from "react-hot-toast";
import TableLoading from "../../../components/TableLoading";
import svg27 from "../../../assets/svg/svg27.svg";

export default function LedgerDetailsTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { itemLedgerData, loading, itemLedgerCount } = useSelector(
    (state) => state.dropdown
  );
  const { staffloading } = useSelector((state) => state.staff);
  const { folderObj } = useSelector((state) => state.folder);

  const [open, setopen] = useState(false);

  function handleCancel() {
    setopen(false);
  }

  const [searchInput, setsearchInput] = useState(null);

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
  };

  const filterDataList = searchInput
    ? itemLedgerData?.filter((item) =>
        item?.ilMovementType?.toLowerCase().includes(searchInput.toLowerCase())
      )
    : itemLedgerData;

  const [prodd, setProdd] = useState("");
  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const showModalDelete = async () => {
    setIsModalOpenDelete(true);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      deleteItemLedger({
        ilId: prodd?.ilId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await fetchItemLedgerData();
      await setIsModalOpenDelete(false);
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const handleAdd = async () => {
    await setopen(true);
    await setProdd("");
  };
  const handleEdit = async () => {
    setopen(true);
  };

  const settingItems = [
    {
      key: "3",
      label: (
        <Link
          onClick={handleEdit}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Edit
        </Link>
      ),
    },
    {
      key: "1",
      label: (
        <Link
          onClick={showModalDelete}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Delete
        </Link>
      ),
    },
  ];

  const columns = [
    {
      title: "Movement Type",
      dataIndex: "ilMovementType",
      sorter: (a, b) => a.ilMovementType.localeCompare(b.ilMovementType),
    },
    {
      title: "Quantity",
      dataIndex: "ilQuantity",
      sorter: (a, b) => a.ilQuantity - b.ilQuantity,
    },
    {
      title: "Unit Cost",
      dataIndex: "ilUnitCost",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) => a.ilUnitCost - b.ilUnitCost,
    },
    {
      title: "Total Cost",
      dataIndex: "ilTotalCost",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) => a.ilTotalCost - b.ilTotalCost,
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchItemLedgerData(page, size) {
    dispatch(
      fetchItemLedger({
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        itemId: folderObj?.stId,
      })
    );
  }

  useEffect(() => {
    fetchItemLedgerData();
  }, []);

  const items = [
    {
      key: "1",
      label: "Item Name",
      children: folderObj?.stName,
    },

    {
      key: "2",
      label: "Quantity",
      children: folderObj?.stQuantity,
    },
    {
      key: "3",
      label: "Unit Cost",
      children: <div>{cashConverter(folderObj?.stUnitCost)}</div>,
    },
    {
      key: "4",
      label: "Unit of Measure",
      children: folderObj?.stUnitOfMeasure,
    },
    {
      key: "5",
      label: "Created Date",
      children: <div>{dateForHumans(folderObj?.stCreatedDate)}</div>,
    },
    {
      key: "6",
      label: "Status",
      children: folderObj?.stStatus,
    },
  ];

  console.log("itemLedgerData", itemLedgerData);
  if (loading) return <TableLoading />;

  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Ledger details information"
        subtitle="Manage Ledger details within your institution"
        back={true}
        title1="Store items"
        title2="Ledger items and Details"
      />

      <div className="bg-white rounded-[10px] mt-[1.25rem] h-full">
        <div className="flex flex-col w-full lg:px-10 px-3 ">
          <div className="mt-[1.25rem]">
            <Descriptions
              column={{ xs: 1, sm: 2 }}
              colon={false}
              title="Store item Information"
              items={items}
            />
          </div>
          <div className="flex justify-between items-center">
            <h3 className="font-[700] text-[24px] text-lightBlack dash-title mt-[1.25rem]">
              Ledger Items Details
            </h3>
          </div>
          <div className="mt-5 flex lg:flex-row flex-col gap-y-5 justify-between lg:items-center items-start w-full">
            <div className="w-[16.8125rem] lg:mt-0 mt-3">
              <Search
                searchInput={searchInput}
                handleSearch={handleSearch}
                text={"Search movement type..."}
              />
            </div>

            <div className="w-[250px]">
              <button
                onClick={handleAdd}
                className="cstm-btn flex gap-x-2"
                type="submit"
              >
                <img src={svg56} alt={svg56} /> Add Ledger Item
              </button>
            </div>
          </div>
          <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
            <section>
              <Table
                rowSelection={false}
                className="mt-[1.31rem] w-full"
                scroll={{
                  x: 800,
                }}
                rowKey={(record) => record?.ilId}
                columns={columns}
                dataSource={filterDataList}
                loading={loading}
                pagination={{
                  position: ["bottomCenter"],
                  current: pageIndex + 1,
                  total: itemLedgerCount,
                  pageSize: pageSize,
                  onChange: (page, size) => {
                    setPageIndex(page - 1);
                    setPageSize(size);
                    fetchItemLedgerData(page - 1, size);
                  },
                  showSizeChanger: false,
                  hideOnSinglePage: true,
                }}
              />
            </section>
          </div>
        </div>
      </div>

      <DeleteModal
        isModalOpen={isModalOpenDelete}
        setIsModalOpen={setIsModalOpenDelete}
        prodd={prodd}
        handleDelete={handleDelete}
        loading={staffloading}
        content={`Are you sure you want to delete ${prodd?.ilMovementType}?`}
        title={`Delete ${prodd?.ilMovementType}`}
      />

      <AddLedgerItemModal
        handleFetchData={fetchItemLedgerData}
        open={open}
        handleCancel={handleCancel}
        prodd={prodd}
      />
    </div>
  );
}
